import * as React from 'react';
import assign = require('object-assign');
import { connect } from 'react-redux';
import { renderErrorObject } from '../common/Render';

import { Node as NodeAction } from '../../../actions'

import LoadingCircle from '../../loading/Circle';

import RemoteQuery from '../RemoteQuery';
import RemoteDataUtil from '../util/RemoteDataUtil';

import ISettings from './ISettings';
import IWidgetProps from './IWidgetProps';
import { IReportSettings } from '../../../interfaces';
import IState from '../../../interfaces/states';

interface IWidgetData {
    nodes,
    states,
}

interface IProps {
    widgetId: string,
    widget: React.ComponentClass<IWidgetProps>,
    widgetData: IWidgetData,
    listNodesWithStates: Function,
    requestOptions: Object,
    settings: ISettings,
    reportSettings: IReportSettings,
}

class WidgetContainer extends React.Component<IProps, void> {
    static propTypes = {
        widgetId: React.PropTypes.string.isRequired,
        widget: React.PropTypes.func.isRequired,
        widgetData: React.PropTypes.object.isRequired,
        listNodesWithStates: React.PropTypes.func.isRequired,
        requestOptions: React.PropTypes.object,
        settings: React.PropTypes.object.isRequired,
        reportSettings: React.PropTypes.object.isRequired,
    };

    createQuery(settings: ISettings, reportSettings: IReportSettings) {
        let { includeTags, excludeTags } = settings;

        const query = new RemoteQuery({
            customerId: reportSettings.customerId
        });

        const queryWrapper = {
            query: query.get(),
            agent: false,
            container: false,
        };

        if (settings.displayAgents) {
            queryWrapper.agent = true;
        }

        if (settings.displayContainers) {
            queryWrapper.container = true;
        }

        query.includeTags(includeTags);
        query.excludeTags(excludeTags);

        return queryWrapper;
    }

    fetchBaseData(props: IProps) {
        const { listNodesWithStates, widgetId, requestOptions, settings, reportSettings } = props;

        if (reportSettings.customerId) {
            listNodesWithStates(
                widgetId,
                this.createQuery(settings, reportSettings),
                assign({
                    start: reportSettings.startMs,
                    end: reportSettings.endMs,
                    includeHints: false,
                }, requestOptions)
            );
        }
    }

    componentDidMount() {
        this.fetchBaseData(this.props);
    }

    componentWillReceiveProps(nextProps) {
        const { settings, reportSettings } = this.props;
        if (settings !== nextProps.settings || reportSettings !== nextProps.reportSettings) {
            this.fetchBaseData(nextProps);
        }
    }

    renderLoading() {
        return (
            <LoadingCircle size="xxl" name={this.props.widgetId} infinite />
        );
    }

    render() {
        const { widgetId, widgetData, settings, reportSettings } = this.props;
        const { nodes, states } = widgetData;
        const data = [nodes, states];

        if (RemoteDataUtil.isLoading(data)) {
            return this.renderLoading();
        }

        if (RemoteDataUtil.isError(data)) {
            return renderErrorObject(widgetId, data);
        }

        return (
            <div>
                {React.createElement(this.props.widget, {
                    nodes: nodes ? nodes.data : [],
                    states: states ? states.data : [],
                    settings: settings,
                    reportSettings: reportSettings,
                })}
            </div>
        );
    }
}

const mapStateToProps = (state: IState, props) => ({
    widgetData: state.widgetData[props.widgetId] || { nodes: null, states: null },
    reportSettings: state.reportSettings,
    settings: (state.reportTemplate.byId[props.widgetId] || {}).settings,
});

export default connect(
    mapStateToProps,
    {
        listNodesWithStates: NodeAction.listNodesWithStates,
    }
)(WidgetContainer);


// WEBPACK FOOTER //
// ./src/components/widget/StateWidgetContainer/StateWidgetContainer.tsx